module.exports = __webpack_public_path__ + "img/SEJ_general_qr_success_response.851a218a.png";